import React, { Component } from 'react'
import Web3 from 'web3'
import Ticket1_0 from '../Ticket1_0/Ticket1_0';
import TicketInstaller1_0 from '../Ticket1_0/TicketInstaller1_0';
import Freebies1_0 from '../Freebies1_0/Freebies1_0';
import FreebiesInstaller1_0 from '../Freebies1_0/FreebiesInstaller1_0';
import PairSwapper1_0 from '../PairSwapper1_0/PairSwapper1_0';
import PairSwapperInstaller1_0 from '../PairSwapper1_0/PairSwapperInstaller1_0';

import './css.css';



class InstallerManager extends Component {
constructor(props){
    super()
    this.loadModules = this.loadModules.bind(this)
    this.state={
        focus:"",
    enabled_items:[],
    disabled_items:[],
    ticket1_0installer:false,
    freebies1_0installer:false,
    swapper1_0installer:false
}
this.renderAgain = this.renderAgain.bind(this);
this.enable = this.enable.bind(this);
}

async getCode(address){
    console.log("getCode"+address)
    let t=0
try{
    const { REACT_APP_TICKETABI } = process.env;

let module = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), address)
let codex=await module.methods.code().call()
t=codex
}catch(f){}
return t
}

renderAgain(){
 
 this.props.reset()
    this.render()
}

enable(factory){
 if(factory=="ticket1_0installer")
    this.setState({ticket1_0installer:true})
if(factory=="freebies1_0installer")
    this.setState({freebies1_0installer:true})
if(factory=="swapper1_0installer")
    this.setState({swapper1_0installer:true})
    this.render()
}

    componentDidMount(){
      //this.loadModules()
      this.loadInstallers()
      this.render()
    }

    async loadInstallers(){
        let db=this.props.db
        console.log("load installers BOX: ",db)
        let a=[]
        await window.ethereum.enable().then(async function (accounts) {   
            const { REACT_APP_HAPPYBOXABI } = process.env;
            const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), db) 
            const { REACT_APP_TICKET1_0FACTORY } = process.env;
            const { REACT_APP_FREEBIES1_0FACTORY } = process.env;
            const { REACT_APP_PAIRSWAPPER1_0FACTORY } = process.env;
let t=await happybox.methods.modules(REACT_APP_TICKET1_0FACTORY).call()
let f=await happybox.methods.modules(REACT_APP_FREEBIES1_0FACTORY).call()
let p=await happybox.methods.modules(REACT_APP_PAIRSWAPPER1_0FACTORY).call()
            a.push(t)
            a.push(f)
            a.push(p)
          console.log("InstallerManager loadInstallers()",t)
        })
        this.setState({focus:db})
        await this.setState({ticket1_0installer:a[0],freebies1_0installer:a[1],swapper1_0installer:a[2]})
        this.render()
    }

  
  

   async loadModules(){
    let total_modules=[]
    let total_disabled_modules=[]
    let db=this.props.db
    let rendAgain=this.renderAgain
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_HAPPYBOXABI } = process.env;
        const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), db) 
        
        let count=0;
        for(let i=0;i<count+1;i++){
            let addr
            let found=false
            try{
                addr=await happybox.methods.modules_list(i).call()
            console.log("MODULE ADDRESS: "+addr)
                found=true
                count++
            }catch(e){console.log("InstallerManager loadModules()",e)}  
            if(found){
                
                
                let code=0
                
                
                try{
                    const { REACT_APP_TICKETABI } = process.env;
                let module = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), addr)
                let codex=await module.methods.code().call()
                code=codex
                }catch(f){console.log("InstallerManager codex",f)}
                

                let enabled=await happybox.methods.modules(addr).call()
                let t

                if(code==4)t=<Ticket1_0 address={addr} key={i} enabled={enabled} box={db} reset={rendAgain}></Ticket1_0>
                if(code==7)t=<Freebies1_0 address={addr} key={i} enabled={enabled} box={db} reset={rendAgain}></Freebies1_0>
                if(code==9)t=<PairSwapper1_0 address={addr} key={i} enabled={enabled} box={db} reset={rendAgain}></PairSwapper1_0>
                
                if(enabled){
                    total_modules.push(t)
                }else{
                    total_disabled_modules.push(t)
                }
              
            }
            
        console.log(`modules: ${count}`)
        }
    
    })
    this.setState({enabled_items : total_modules})
    this.setState({disabled_items : total_disabled_modules})
    this.render()
}

    render(props){
    console.log(this.state.enabled_items)
    if(this.props.db!=this.state.focus)this.loadInstallers()
    let addr
          let enabled
            let i
        return ( 
            
        <div className="Installer_Modules_Panel dark darkblue text white">
            <img className="Installer_add_item_icon" src="https://i.imgur.com/YKhumij.png"></img>
            <div className="clear"></div> 
            <div className="Installer_Modules_Container light lightblue">  
            
            <TicketInstaller1_0 address={addr} key={i} enabled={this.state.ticket1_0installer} box={this.props.db} reset={this.renderAgain} enable={this.enable}></TicketInstaller1_0>
            <FreebiesInstaller1_0 address={addr} key={i} enabled={this.state.freebies1_0installer} box={this.props.db} reset={this.renderAgain} enable={this.enable}></FreebiesInstaller1_0>
            <PairSwapperInstaller1_0 address={addr} key={i} enabled={this.state.swapper1_0installer} box={this.props.db} reset={this.renderAgain} enable={this.enable}></PairSwapperInstaller1_0>
              
            </div>
        </div>
            
        );
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}



        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default InstallerManager